import React from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EmployeeMain from '../Employee/EmployeeMain';
import LeaveMain from '../Leave/LeaveMain';
import AttendanceMain from '../Attendance/AttendanceMain';
import DeductionMain from '../Deduction/DeductionMain';
import AllowanceMain from '../Allowance/AllowanceMain';
import PayslipMain from '../Payslip/PayslipMain';
import PayrunMain from '../Payrun/PayrunMain';
import CustomTabs from '../../components/Shared/CustomTabs';

export default function PayrollMain() {
  const { t } = useTranslation();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const tabValues = ['employees', 'attendances', 'leaves', 'deductions', 'allowances', 'payruns', 'payslips'];
  const tabParam = searchParams.get('tab');
  let activeTabIndex = 0;
  if (tabParam !== null) {
    if (!isNaN(Number(tabParam)) && Number(tabParam) >= 0 && Number(tabParam) < tabValues.length) {
      activeTabIndex = Number(tabParam);
    } else {
      const foundIdx = tabValues.indexOf(tabParam.toLowerCase());
      if (foundIdx !== -1) {
        activeTabIndex = foundIdx;
      }
    }
  } else if (location.state?.activeTabIndex != null) {
    activeTabIndex = Number(location.state.activeTabIndex);
  }
  const handleTabChange = (newIndex) => {
    setSearchParams({ tab: tabValues[newIndex] || newIndex });
  };
  const tabs = [
    {
      name: 'employees',
      content: <EmployeeMain />
    },
    {
      name: 'attendances',
      content: <AttendanceMain />
    },
    {
      name: 'leaves',
      content: <LeaveMain />
    },
    {
      name: 'deductions',
      content: <DeductionMain />
    },
    {
      name: 'allowances',
      content: <AllowanceMain />
    },
    {
      name: 'payruns',
      content: <PayrunMain />
    },
    {
      name: 'payslips',
      content: <PayslipMain />
    }
  ];

  return (
    <div>
      <div>
        <CustomTabs
          tabs={tabs}
          activeTabIndex={activeTabIndex}
          setActiveTabIndex={handleTabChange}
        />
      </div>
    </div>
  );
}
